// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.visual-module_badgeContainer__OqX6M {
    display: inline-flex;
    position: absolute;
    bottom: -4px;
    right: -6px;
}

.visual-module_badgeContainer__OqX6M.visual-module_medium__x7Jjf {
    bottom: 0;
    right: 0;
}

.visual-module_selectedContainer__WxeEZ {
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background: var(--visual-selected-bg);
    border: 1px solid var(--visual-selected-border);
    box-sizing: border-box;
}
`, "",{"version":3,"sources":["webpack://./../../packages/consumer/src/widgets/Image/styles/visual.module.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,qCAAqC;IACrC,+CAA+C;IAC/C,sBAAsB;AAC1B","sourcesContent":[".badgeContainer {\n    display: inline-flex;\n    position: absolute;\n    bottom: -4px;\n    right: -6px;\n}\n\n.badgeContainer.medium {\n    bottom: 0;\n    right: 0;\n}\n\n.selectedContainer {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    border-radius: 50%;\n    background: var(--visual-selected-bg);\n    border: 1px solid var(--visual-selected-border);\n    box-sizing: border-box;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"badgeContainer": `visual-module_badgeContainer__OqX6M`,
	"medium": `visual-module_medium__x7Jjf`,
	"selectedContainer": `visual-module_selectedContainer__WxeEZ`
};
export default ___CSS_LOADER_EXPORT___;
